import { Link } from "react-router-dom";
import { Typography as T } from "@mui/material";
import { colors } from "../styles";
import { adminLoginFullPath, employeeLoginFullPath } from "../routes/paths";

export const NoRoutePage = () => {
  return (
    <div className="flex flex-col items-center justify-center w-100 h-screen">
      <div className="w-50">
        <>
          <T variant="lgReg" color={colors.red}>
            Whoops, this page doesn't exist. We're sorry about that. Try one of
            these to get back on track:
          </T>
          <div className="mt-16">
            <T>
              If you are an admin, you can login in{" "}
              <Link to={adminLoginFullPath}>here.</Link>
            </T>
            <T>
              If you are an employee, you can login in{" "}
              <Link to={employeeLoginFullPath}>here.</Link>
            </T>
          </div>
        </>
      </div>
    </div>
  );
};

export default NoRoutePage;
